/**
 * Compute the next CT slice index given a wheel-event `deltaY`.
 *
 * Convention: scroll down (positive `deltaY`) advances to the next
 * slice; scroll up reverses. One slice per wheel notch regardless of
 * `deltaY` magnitude, so a granular trackpad scroll feels the same as
 * a notched mouse wheel.
 *
 * `min` is implicitly 0 (the slice-index lower bound across all CT
 * planes); the caller passes only the upper bound.
 */
export function nextSliceIndex(
    deltaY: number,
    currentIndex: number,
    maxIndex: number,
): number {
    const step = Math.sign(deltaY);
    return Math.max(0, Math.min(maxIndex, currentIndex + step));
}
